import { TuitionFeeCheck } from '@/plugins/api'

export default {
  namespaced: true,
  state: {
    checks: [],
    count: [],
  },
  actions: {
    async fetch({ state, commit }, query) {
      const checks = await TuitionFeeCheck.fetch(query)
      commit('changeState', { checks: checks })
    },
    async count({ state, commit }, query) {
      const count = await TuitionFeeCheck.count(query)
      commit('changeState', { count: count })
    },
  },
  mutations: {
    setChecks(state, data) {
      state.checks = data
    },
  },
  getters: {
    checks(state) {
      return state.checks
    },
  },
}
